import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin, Phone } from 'lucide-react';
import { CONTACT, ADDRESS_SINGLE_LINE } from '../../data/site';

/**
 * The site's one primary conversion, and the last block before the footer
 * so no page ends on a section. Reused, not rewritten per section.
 */
export function CTABlock() {
  return <section data-component-id="C04" aria-labelledby="cta-heading" className="bg-ink-deep py-16 sm:py-24" data-id="element-401" data-mp="1w0gcy0gnaoau">
      <div className="mx-auto max-w-container px-gutter-sm sm:px-gutter-md lg:px-gutter-lg" data-id="element-402" data-mp="2ntyxr1tidagv">
        <div className="grid gap-10 lg:grid-cols-[1.25fr_1fr] lg:items-end" data-id="element-403" data-mp="2js3z652ypb6s">
          <div data-id="element-404" data-mp="2ju87cz7w8wcv">
            <p className="mb-4 border-l-4 border-flame pl-3 text-sm font-black uppercase tracking-[0.2em] text-flame" data-id="element-405" data-mp="2et11j5pba78u">
              Come and find us
            </p>
            <h2 id="cta-heading" className="font-bebas text-5xl tracking-wide text-cream sm:text-6xl" data-id="element-406" data-mp="18e9v6mhf5u7f">
              The kettle's on.
            </h2>
            <p className="mt-4 max-w-prose text-lg font-medium leading-relaxed text-cream/80" data-id="element-407" data-mp="10t8pjnsc3ixi">
              Nothing here needs booking. There's plenty of room in the car
              park for bikes and cars, so park up and come in. Friday is bike
              night, every week all year round. We're closed Mondays.
            </p>
          </div>

          <div className="flex flex-col gap-3" data-id="element-408" data-mp="i2hi4rrwq2lr">
            <Link to="/whats-on" className="group inline-flex items-center justify-between gap-3 rounded-container bg-flame px-6 py-4 text-base font-black uppercase tracking-wide text-white transition-colors duration-200 ease-out-expo hover:bg-flame-dark focus:outline-none focus:ring-2 focus:ring-flame focus:ring-offset-2 focus:ring-offset-ink-deep" data-id="element-409" data-mp="i0o9j6xqh8b4">
              See what's on
              <ArrowRight className="h-5 w-5 transition-transform duration-200 ease-out-expo group-hover:translate-x-1 motion-reduce:transform-none" aria-hidden="true" data-id="element-410" data-mp="3vb3v777jzg3t" />
            </Link>

            <a href={CONTACT.telephoneHref} className="inline-flex items-center gap-3 rounded-container border-2 border-cream/25 px-6 py-4 text-base font-bold text-cream transition-colors duration-200 ease-out-expo hover:border-cream/50 hover:bg-white/5 focus:outline-none focus:ring-2 focus:ring-cream focus:ring-offset-2 focus:ring-offset-ink-deep" data-id="element-411" data-mp="210dx6q625hlg">
              <Phone className="h-5 w-5 shrink-0 text-flame" aria-hidden="true" data-id="element-412" data-mp="2kod75yssskpt" />
              <span data-id="element-413" data-mp="2fpthpoezwqsp">
                Call {CONTACT.telephone}
              </span>
            </a>

            <p className="flex items-start gap-3 px-1 text-sm font-medium text-cream/70" data-id="element-414" data-mp="2aqp9p13t4z3y">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-flame" aria-hidden="true" data-id="element-415" data-mp="2at36pfi1sle5" />
              <span data-id="element-416" data-mp="zbacpxblm78u">{ADDRESS_SINGLE_LINE}</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}